var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-root"},[_c('Header',{attrs:{"label":_vm.$t('shared.userNavSection.referrals'),"overlap":"small"}}),_c('MainLayout',{attrs:{"margin-top":""}},[_c('BuyapowaRefer',{attrs:{"slot":"center"},slot:"center"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }